export type PlaygroundEndpoint = {
  id: string;
  method: 'GET' | 'POST';
  path: string;
  label: string;
};

/** endpoint ที่ยิงทดสอบได้จากหน้า Playground */
export const PLAYGROUND_ENDPOINTS: PlaygroundEndpoint[] = [
  { id: 'create-order', method: 'POST', path: '/orders', label: 'Create Order' },
  { id: 'get-order', method: 'GET', path: '/orders/:order_number', label: 'Get Order Status' },
  { id: 'list-orders', method: 'GET', path: '/orders', label: 'List Orders' },
  { id: 'create-payout', method: 'POST', path: '/payout', label: 'Create Payout' },
  { id: 'get-payout', method: 'GET', path: '/payout/:payout_number', label: 'Get Payout Status' },
  { id: 'get-balance', method: 'GET', path: '/wallet', label: 'Get Balance' },
  { id: 'get-banks', method: 'GET', path: '/banks', label: 'List Banks' },
  { id: 'create-slip-order', method: 'POST', path: '/slip-orders', label: 'Create Slip Order' },
  { id: 'get-banks-slips', method: 'GET', path: '/banks_slips', label: 'Banks for Slips' },
  { id: 'verify-slip', method: 'POST', path: '/orders/:order_number/verify-slip', label: 'Verify Slip' },
];

export type PlaygroundField = {
  key: string;
  label: string;
  required?: boolean;
  type?: string;
};

/** ฟอร์มของ create-order / create-slip-order */
export const ORDER_FORM_FIELDS: PlaygroundField[] = [
  { key: 'amount', label: 'Amount (THB)', required: true, type: 'number' },
  { key: 'reference_id', label: 'Reference ID', required: true },
  { key: 'bank_name', label: 'Bank Name', required: true },
  { key: 'bank_number', label: 'Bank Number', required: true },
  { key: 'customer_name', label: 'Customer Name' },
  { key: 'customer_email', label: 'Customer Email' },
  { key: 'customer_phone', label: 'Customer Phone' },
];

/** ฟอร์มของ create-payout */
export const PAYOUT_FORM_FIELDS: PlaygroundField[] = [
  { key: 'amount', label: 'Amount (THB)', required: true, type: 'number' },
  { key: 'bank_account_name', label: 'Account Name', required: true },
  { key: 'bank_account_number', label: 'Account Number', required: true },
  { key: 'bank_name', label: 'Bank Name', required: true },
  { key: 'reference_id', label: 'Reference ID' },
  { key: 'note', label: 'Note' },
];

/** endpoint ที่ไม่ต้องกรอกอะไรเลย */
export const NO_PARAM_ENDPOINTS = ['list-orders', 'get-balance', 'get-banks', 'get-banks-slips'];
